import { render, staticRenderFns } from "./i_detail.vue?vue&type=template&id=8f4e370c&"
import script from "./i_detail.vue?vue&type=script&lang=js&"
export * from "./i_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports